import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '../../common/components/Button'
import { useInitChat } from '../../chat/hooks/useInitChat'

export const QuoteNewChatButton: FC = () => {
  const { t } = useTranslation()
  const initChat = useInitChat()

  return (
    <Button
      big
      onClick={() => {
        initChat()
      }}
    >
      {t('New quote')}
    </Button>
  )
}
